module.exports = __webpack_public_path__ + "static/media/9_r_okno_76.35_1.57.da0673ef.png";